<template>
  <div class="splash-cnt">
    <div class="splash-box">
      <span class="img-box">
        <img src="../assets/images/logo.svg" />
      </span>
    </div>
    <loadingIcon v-if="loading" />
    <Toaster :dataValue="toasterData" />
  </div>
</template>
<script>
import loadingIcon from "../components/icons/loadingIcon";
import Toaster from "../components/Toaster";
import { SessionHelper } from "../utils/session";
export default {
  name: "Splash",
  components: {
    loadingIcon,
    Toaster,
  },
  data() {
    return {
      toasterData: {},
      loading: true,
      adslist: false,
      walletInfo: false,
    };
  },
  mounted() {
    this.$store.dispatch({type:'userDetail'}).then((data)=>{
      console.log('data uusrr', data.data.mobile_no)
      if(!SessionHelper.refereshJwtToken()){
       this.$store.dispatch({ type: "getJwt", payload:`/${data.data.mobile_no}/${SessionHelper.getCookie('X-Auth-Id')}` }).then((data) => {
       SessionHelper.setCookie("Authorization", data);
       this.adsList();
       this.walletDetail();
     });
    }else{
       SessionHelper.refereshJwtToken()
       this.$store.dispatch({ type: "getJwt", payload:`/${data.data.mobile_no}/${SessionHelper.getCookie('X-Auth-Id')}` }).then((data) => {
       SessionHelper.setCookie("Authorization", data);
       this.adsList();
       this.walletDetail();
     });
    } 
    })

    // if(!SessionHelper.refereshJwtToken()){
    //    this.$store.dispatch({ type: "getJwt", payload:`/8349351712/${SessionHelper.getCookie('X-Auth-Id')}` }).then((data) => {
    //    SessionHelper.setCookie("Authorization", data);
    //    this.adsList();
    //    this.walletDetail();
    //  });
    // }else{
    //    SessionHelper.refereshJwtToken()
    //    this.$store.dispatch({ type: "getJwt", payload:`8349351712/${SessionHelper.getCookie('X-Auth-Id')}` }).then((data) => {
    //    SessionHelper.setCookie("Authorization", data);
    //    this.adsList();
    //    this.walletDetail();
    //  });
    // } 
  },
  methods: {
    walletDetail() {
      this.$store.dispatch({ type: "getWalletHistory" }).then((data) => {
        console.log("=data history=", data);
        if (data.httpStatus === 200) {
          this.$store.commit("AdsTransaction", data.data);
          this.$router.replace("/dashboard");
          this.adslist = false;
          this.loading = false;
        } else {
          this.toasterData = {
            status: true,
            msg: data.message,
            timeoutMs: "5000",
            color: "#000",
          };
          this.loading = false;
        }
      });
    },
    adsList() {
      this.$store.dispatch({ type: "Adslist" }).then((data) => {
        if (data.httpStatus === 200) {
          this.$store.commit("adsList", data.data);
          // this.$router.replace("/dashboard");
          this.walletInfo = true;
          this.loading = false;
        } else {
          this.toasterData = {
            status: true,
            msg: data.message,
            timeoutMs: "5000",
            color: "#000",
          };
          this.loading = false;
        }
      });
    },
  },
};
</script>
